import { Component, Input, OnInit, OnDestroy, ElementRef, ViewChild, Inject, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {_} from '../../../js/globals';

@Component({
    standalone: false,
    selector: 'shiny-app',
    templateUrl: '../app/content-components/shiny-app/shiny-app.view.html',
    styleUrls: ['../app/content-components/shiny-app/shiny-app.style.css']
})
export class ShinyAppComponent implements OnInit, OnDestroy {

    @Input() url: any = '';
    @Input() name: string = '';
    @Input() minAppHeight: number = 500;
    @Input() loadTimeoutMs: number = 30000; // 30 seconds default
    @Input() reloadTimeoutMs: number = 10000; // 10 seconds default
    @ViewChild('iframe', { static: false }) iframeElement!: ElementRef<HTMLIFrameElement>;
    @Output() shinyAppLoaded = new EventEmitter<void>();
    @Output() shinyAppError = new EventEmitter<string>();

    private shinyAppHasLoaded: boolean = false;
    private messageListener?: (event: MessageEvent) => void;
    private loadTimeout?: number;
    private reloadTimeout?: number;

    _:any;

    constructor(@Inject(DomSanitizer) private sanitizer: DomSanitizer,
        @Inject(ElementRef) private hostElement: ElementRef<HTMLElement>) {
        this._ = _;
        
    }
    private setShinyAppHeight(height: number) {
        // Access the root #shinyApp element
        const shinyAppElement = this.hostElement.nativeElement.querySelector('#shinyApp') as HTMLElement;
        if (shinyAppElement) {
            shinyAppElement.style.height = `${height}px`;
        }
        if(this.iframeElement) {
            this.iframeElement.nativeElement.style.height = `${height}px`;
        }
    }

    private setupMessageListener() {
        this.messageListener = (event: MessageEvent) => {
           
            // Shiny App height response
            if (event.data.type === 'shiny-height-response') {
                const height = this._.get(event,"data.height");
                const eventSource = this._.get(event,"data.eventSource");
                console.log('📏 Received height from Shiny app:', height);
                console.log('📏 The source of the event was:', eventSource);
                if(height >= this.minAppHeight) {             
                    this.setShinyAppHeight(height);
                    // Emit loaded event only once to the parent page once we can reasonably sure
                    // the shiny app has at least mostly loaded and the loading spinner can be replaced.
                    if(!this.shinyAppHasLoaded) {
                        this.shinyAppHasLoaded = true;
                         this.clearLoadTimeout();
                        this.shinyAppLoaded.emit();
                    }
                } else {
                   // console.log('📏 Received height is below minimum threshold did not set parent height');
                    this.setShinyAppHeight(this.minAppHeight);
                }
            }

            // Shiny App disconnected notification
            if (event.data.type === 'shiny-disconnected-panel') {
                console.warn('⚠️ Received Shiny app disconnected message');
               // this.startReloadTimeout();
            }
            if(event.data.type === 'shiny-connected' || event.data.type === 'shiny-reconnected') {
                console.log('✅ Received Shiny app reconnected message ######');
                this.clearReloadTimeout();
            }
           
        };

        window.addEventListener('message', this.messageListener);
    }
    private requestHeightFromShinyApp() {
        if (this.iframeElement?.nativeElement?.contentWindow) {
            console.log('📤 Requesting height from Shiny app...');
            
            this.iframeElement.nativeElement.contentWindow.postMessage({
                type: 'request-height',
                source: 'angular-parent'
            }, this.url);
        }
    }

     private startLoadTimeout() {
        this.clearLoadTimeout();
        
        console.log(`⏰ Starting load timeout (${this.loadTimeoutMs}ms)`);
        this.loadTimeout = window.setTimeout(() => {
            if (!this.shinyAppHasLoaded) {
                console.error('⏰ Shiny app load timeout reached');
                this.onIframeTimeout();
            }
        }, this.loadTimeoutMs);
    }

    private clearLoadTimeout() {
        if (this.loadTimeout) {
            console.log('⏰ Clearing load timeout');
            clearTimeout(this.loadTimeout);
            this.loadTimeout = undefined;
        }
    }

    private startReloadTimeout() {
        this.clearReloadTimeout();
        console.log(`⏰ Starting reload timeout (${this.reloadTimeoutMs}ms)`);
        this.reloadTimeout = window.setTimeout(() => {
            console.log('⏰ Reloading iframe after timeout');
            this.reloadIframe();
        }, this.reloadTimeoutMs);
    }
    private clearReloadTimeout() {
        if (this.reloadTimeout) {
            console.log('⏰ Clearing reload timeout');  
            clearTimeout(this.reloadTimeout);
            this.reloadTimeout = undefined;
        }
    }

    private reloadIframe() {
        if (this.iframeElement?.nativeElement) {
            console.log('🔄 Reloading iframe...');
            
            // Reset component state
            this.shinyAppHasLoaded = false;
            this.clearLoadTimeout();
            this.clearReloadTimeout();
            
            // Simple reload - just reset the src
            //this.iframeElement.nativeElement.src = this.iframeElement.nativeElement.src;
            
            // Restart timeout
           // this.startLoadTimeout();
        }
    }   
    
    isIframeUrlValid(): boolean {
        return this.url && this.url.trim() !== '';
    }

    onIframeLoad() {
        this.requestHeightFromShinyApp();
    }
    onIframeTimeout() { 
       console.error('Shiny app failed to load within the expected time.');
       this.clearLoadTimeout();
       this.shinyAppError.emit('Failed to load Shiny application');
    }
    ngOnInit() {
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
        this.startLoadTimeout();
        this.setupMessageListener();
    }

    ngOnDestroy() {
         if (this.messageListener) {
            window.removeEventListener('message', this.messageListener);
        }
         // Cleanup logic for iframe
        if (this.iframeElement && this.iframeElement.nativeElement) {
            // Remove the iframe's src to stop loading content
            this.iframeElement.nativeElement.src = 'about:blank';

            // Remove any event listeners (if added)
            // example:
            // this.iframeElement.nativeElement.onload = null;
            // this.iframeElement.nativeElement.onerror = null;
        }
        this.shinyAppLoaded.complete();
        this.shinyAppError.complete();

        this.clearLoadTimeout();
        this.clearReloadTimeout();
    }

}
